export function descrevaFormaDeEntrega(pedido: any): string {
  const formaDeEntrega = pedido?.formaDeEntrega || '';
  const nomeLojaRetirada = pedido?.empresaExecutora?.nome;

  if(!pedido?.retirar || !pedido?.interloja || !nomeLojaRetirada)
    return formaDeEntrega;

  return `${formaDeEntrega || 'Retirar'} em ${nomeLojaRetirada}`;
}

export function obtenhaNomeLojaVenda(pedido: any, modoGrupoLojas: boolean): string | null {
  if(!modoGrupoLojas)
    return null;

  return pedido?.empresa?.nome || null;
}
